<script context="module">
  const BIG_TITLE_LENGTH_LIMIT = 25;
  const BIG_TITLE_WORD_LENGTH_LIMIT = 12;

  export function getPageHeadingClass(isCategoryPage, title) {
    const longTitle = title.length > BIG_TITLE_LENGTH_LIMIT;
    const containsLongWords = title.split(" ").some((w) => w.length > BIG_TITLE_WORD_LENGTH_LIMIT);

    let typeStackClass = "short-heading-1";

    if (!isCategoryPage || longTitle) {
      typeStackClass = "long-heading-1";
    } else if (!longTitle && containsLongWords) {
      typeStackClass = "long-heading-1 md:short-heading-1";
    }
    return typeStackClass;
  }
</script>

<script>
  import { getContext } from "svelte";
  import Heading from "../Heading.svelte";

  export let title = "";

  const isCategoryPage = getContext("pageType") === "categoryPageTemplate";

  let clazz = "";
  export { clazz as class };
</script>

<Heading
  class={`${getPageHeadingClass(isCategoryPage, title)} text-center text-neutral-900 ${clazz}`}
  text={title}
/>
